<template>
  <ModalLayout icon="delete" title="Delete creative?" @close="close">
    Are you sure you want to delete <strong>'{{ meta?.creative?.name }}'</strong>? This action cannot be undone.
    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" @click="ctaDelete" :loading="loading" icon="el-icon-delete" type="danger">Delete</el-button>
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from '../ModalLayout.vue'
export default {
  name: 'DeleteCreative',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async ctaDelete() {
      this.loading = true
      await this.$store.dispatch('socialBoostCampaign/deleteCreative', {
        creative_id: this.meta.creative.id,
      })
      this.$Modal.bus.$emit('reload:creatives')
      this.close()
      this.loading = false
    },
  },
}
</script>
